import React from 'react';
import Layout from 'Layouts/Back';
import Button from '@material-ui/core/Button';
import bemit from 'Functions/bemit';
import Link from 'Pure/Link';
const ExportHotelsDataPage = () => {
  return /*#__PURE__*/React.createElement(Layout, {
    page_title: "Export des donn\xE9es"
  }, /*#__PURE__*/React.createElement("div", {
    className: "o-content dashboard-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "u-flex u-flex-column u-flex-gap-15"
  }, /*#__PURE__*/React.createElement("p", null, "G\xE9n\xE9ration d'un fichier CSV contenant les donn\xE9es des \xE9tablissements et leurs espaces"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    href: "/admin/exportHotelDataCSV",
    className: bemit('c-flat-btn', ['primary']),
    target: "_blank",
    component: Link
  }, "G\xE9n\xE9rer le CSV")))));
};
export default ExportHotelsDataPage;
